
import { RecentInvoicesTable } from "./RecentInvoicesTable";
import { useStudentBilling } from "@/hooks/useFinanceData";
import { useOptimisticBilling } from "@/hooks/useOptimisticBilling";

interface FinancesTableContainerProps {
  billingPeriodId?: string;
}

export const FinancesTableContainer = ({ billingPeriodId }: FinancesTableContainerProps) => {
  const { billing, loading: billingLoading, refetch: refetchBilling } = useStudentBilling(billingPeriodId);
  const { billing: optimizedBilling, loadingBillId, handleMarkAsPaid, handleMarkAllAsPaid } = useOptimisticBilling(billing, refetchBilling);

  return (
    <RecentInvoicesTable
      billing={optimizedBilling}
      billingLoading={billingLoading}
      loadingBillId={loadingBillId}
      onMarkAsPaid={handleMarkAsPaid}
      onMarkAllAsPaid={handleMarkAllAsPaid}
      refetchBilling={refetchBilling}
    />
  );
};
